<template>
    <v-container fluid>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-btn color="quaternary" dark class="ml-2 float-right">Download Report</v-btn>
                </v-row>
                <v-row>
                    <card-view-base :item="item" :filter="filter" :cards="cards" />
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import securityService from '../services/securityService'

    export default {
        props: [
            'filter',
            'showExpand'
        ],

        components: {
            cardViewBase: () => import('../components/CardViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Audit', apiMethod: 'Audits', form: () => import('../forms/AuditForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Corrective Action Request', apiMethod: 'CorrectiveActionRequests', parentForeignKey: 'auditId', form: () => import('../forms/CorrectiveActionRequestForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                mainForm: () => import('../forms/AuditForm'),
                claimName: 'Audits',
                apiMethod: 'Audits',
                id: null,
                item: {},
                auditorId: null
            }
        },

        async mounted() {
            this.auditorId = securityService.getAuditorId();
            if (!this.auditId) {
                this.id = this.$route.params.id;
            }
            else {
                this.id = this.auditId;
            }
            var response = await axios.get('/api/Audits/' + this.id);
            this.item = response.data;
            this.cards[1].postApiMethod = this.correctiveActionRequestApiMethod;
        },

        computed: {
            auditFilter() {
                var filter = { auditId: this.id };
                if (this.auditorId) {
                    filter.auditorId = this.auditorId;
                }
                return filter;
            },
            correctiveActionRequestApiMethod() {
                return this.hasClaim('CorrectiveActionRequestFullWriteAccess') ? 'CorrectiveActionRequests' : 'CorrectiveActionRequests/MemberComments';
            }
        }
    };
</script>
